import { createAction, ActionType } from "typesafe-actions"
import { ConfirmModalState } from "../reducers/confirmModalReducer"

export const setConfirmModalAction = createAction('SET_CONFIRM_MODAL')<{ confirmModal: ConfirmModalState }>()
export const clearConfirmModalAction = createAction('CLEAR_CONFIRM_MODAL')<undefined>()

export type ConfirmModalActions =
  | ActionType<typeof setConfirmModalAction>
  | ActionType<typeof clearConfirmModalAction>